/*アコーディオン*/
$(function ($) {
  $(".accordion > dt").click(function () {
    $(this).next("dd:not(:animated)").slideToggle("fast");
    $(this).toggleClass("open");
  });

  $(".accordion > dt > dt").click(function () {
    $(this).next("dd:not(:animated)").slideToggle("fast");
    $(this).toggleClass("open");
  });
});

/*スライダー*/
$(window).ready(function () {
  // var $slideshow = $(".top_slider");
  var $slide = $(".slide");

  $(function () {
    /*randomize($slide);*/
    var $slideshow = $(".top_slider")
      .slick({
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnFocus: false,
        pauseOnHover: false,
        speed: 2000,
        infinite: true,
        dots: true,
        arrows: false,
        fade: true,
      })
      .on({
        beforeChange: function (event, slick, currentSlide, nextSlide) {
          $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
          $(".slick-slide .fv_photo", this).eq(nextSlide).addClass("slide-animation");
        },
        afterChange: function () {
          $(".preve-slide .fv_photo", this).removeClass("slide-animation");
          $(".preve-slide", this).removeClass("preve-slide");
        },
      });
    $slideshow.find(".slick-slide .fv_photo").eq(0).addClass("slide-animation");
  });
});

/*スライダー所品ページ用*/
$(window).ready(function () {
  // var $slideshow = $(".top_slider");
  var $slide = $(".slide");

  $(function () {
    /*randomize($slide2);*/
    var $slideshow = $(".item_slider").slick({
      autoplay: false,
      autoplaySpeed: 4000,
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 2000,
      infinite: true,
      dots: true,
      arrows: false,
      fade: true,
    });
  });
});

/*ハンバーガー*/
$(function () {
  //ドロワーメニューの開閉--------------------
  $(".js-navbtn").click(function () {
    $(".js-drawer").slideToggle();

    if ($(".js-fix-body").hasClass("is-fixed")) {
      $(".js-fix-body").removeClass("is-fixed");
    } else {
      $(".js-fix-body").addClass("is-fixed");
    }

    if ($(".js-navbtn").hasClass("checked")) {
      $(".js-navbtn").removeClass("checked");
    } else {
      $(".js-navbtn").addClass("checked");
    }
  });

  $(window).resize(function () {
    // 画面リサイズ時にslidetoggleで付与したHTMLのstyleを削除
    if ($(window).innerWidth() >= 1025) {
      $(".js-drawer").removeAttr("style");
      $(".js-accordion-menu").removeAttr("style");

      if ($(".js-fix-body").hasClass("is-fixed")) {
        $(".js-fix-body").removeClass("is-fixed");
      }

      if ($(".js-accordion-switch").hasClass("is-active")) {
        $(".js-accordion-switch").removeClass("is-active");
      }
    }

    if ($(window).innerWidth() >= 600) {
      $(".js-accordion-switch-sm").next(".js-accordion-menu").removeAttr("style");

      if ($(".js-accordion-switch-sm").hasClass("is-active")) {
        $(".js-accordion-switch-sm").removeClass("is-active");
      }
    }
  });
});

/*スクロールでフェードインしてくる*/
$(function () {
  $(window).scroll(function () {
    $(".fadein").each(function () {
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 200) {
        $(this).addClass("scrollin");
      }
    });
  });
});

/*トップへボタン*/
jQuery(function () {
  var pagetop = $("#page_top");
  var windowWidth = $(window).width();
  var windowSm = 768;
  if (windowSm <= windowWidth) {
    pagetop.hide();
  }

  $(window).scroll(function () {
    if (windowSm <= windowWidth) {
      if ($(this).scrollTop() > 100) {
        //100pxスクロールしたら表示
        pagetop.fadeIn();
      } else {
        pagetop.fadeOut();
      }
    }
  });

  pagetop.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      500
    ); //0.5秒かけてトップへ移動
    return false;
  });
});

jQuery(function () {
  var pagetop = $(".member_btn_right");
  pagetop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      //100pxスクロールしたら表示
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
  });
  pagetop.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      500
    ); //0.5秒かけてトップへ移動
    return false;
  });
});
